export enum LogbookItemFilterStatus {
    New,
    Acknowledged
}